<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isBranchManager()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        Fetch Serial Number Transaction History
                    </div>
                    <div class="card-body overflow-auto">
                        <div class="form-group">
                            <label>Serial No.</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="sl"
                                placeholder="Enter the serial no."
                                @keyup.enter="look"
                            />
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="form-group">
                            <button
                                class="btn btn-danger"
                                style="width: 100% !important"
                                @click="look"
                            >
                                Lookup
                                <span class="right badge badge-success">{{
                                    search_status
                                }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12" v-for="i in results">
                <div class="card">
                    <div class="card-body overflow-auto">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Date:</label>
                                    <b>{{ i.Date }}</b>
                                </div>
                                <div class="form-group">
                                    <label>Document Number:</label>
                                    {{ i.DocumentNumber }}
                                </div>
                                <div class="form-group">
                                    <label
                                        >Host Document Number (POS ID):</label
                                    >
                                    <b>{{ i.HostDocumentNumber }}</b>
                                </div>
                                <div class="form-group">
                                    <label>Warehouse Code:</label>
                                    <h4>{{ i.WarehouseCode }}</h4>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Item Code:</label>
                                    {{ i.ItemCode }}
                                </div>
                                <div class="form-group">
                                    <label>Item Name:</label>
                                    {{ i.ItemName }}
                                </div>
                                <div class="form-group">
                                    <label>Company Ageing:</label>
                                    <b>{{ i.CompanyAgeing }}</b>
                                </div>
                            </div>
                            <div class="col-md-4" float="right">
                                <h1>{{ i.DocumentType }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isBranchManager()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    data() {
        return {
            sl: "",
            results: [],
            search_status: "",
        };
    },

    methods: {
        look() {
            this.search_status = "Searching...";
            axios
                .post("/api/getSlJaathakam", { sl: this.sl })
                .then((response) => {
                    this.results = response.data;
                    this.search_status = "Search Complete";
                });
        },
    },
};
</script>
